import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Adepto** (manuale V1, rr. 1346-1352).
 *
 * Un apprendista stregone, un chierichetto o un agente di basso livello di
 * qualche entità ultraterrena. Specializzato nel supportare il caster del
 * gruppo (recupero Mana, potenziamento incantesimi).
 */
export const adepto: FollowerAbility = {
  id: 'adepto',
  label: 'Adepto',
  description:
    'Un apprendista stregone, un chierichetto o un agente di basso livello di qualche entità ultraterrena. Sia come sia, conta poco più del due di briscola, ma talvolta può tornar comodo pure quello!',
  ranks: [
    {
      rank: 1,
      trigger: 'Quando un Adepto ti *aiuta* a recuperare energie magiche con la mossa *Mana*',
      description: 'Prendi una presa in più del normale.',
    },
    {
      rank: 2,
      trigger: 'Quando un Adepto ti *aiuta* a *lanciare incantesimi*',
      description:
        "Il GM ti dice in anticipo come il sortilegio aumenterà di portata, durata o potenza. Se accetti l'aiuto, ogni conseguenza ricade comunque su di te. Con 10+, l'Adepto può ancora *aiutarti* in questo modo a *lanciare incantesimi* nel corso della giornata. Con 7-9 o 6-, invece, l'Adepto è esausto e non potrà farlo di nuovo finché non vi *accampate*.",
    },
    {
      rank: 3,
      trigger: 'Quando un Adepto ti *aiuta* a *lanciare incantesimi*',
      description:
        "Ottieni gli stessi effetti e le medesime conseguenze descritti per il *Rango 2*, ma, se vuoi, sarà l'Adepto ad assumersi ogni rischio: con un 7-9, non devi scegliere dalla lista; con 6-, le complicazioni che avresti dovuto subire tu, le subisce il povero gregario al posto tuo!",
    },
  ],
};
